import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/canteen/cost-center",
        component: List,
        name: "canteen.cost.center",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/cost-center/create",
        component: Create,
        name: "canteen.cost.center.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/cost-center/:id/edit",
        component: Edit,
        name: "canteen.cost.center.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
